module.exports = __webpack_public_path__ + "experience/innovation/images/area.3050d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/smaa/area.png
// module id = GEPN
// module chunks = 1